import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { Button } from '@/components/Button'
import {
  DialogTrigger,
  Modal,
  Dialog,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from '@/components/Modal'

import ProfileEditor from '../ProfileEditor'
import { UserProfile } from '@/api/types'
import { useTranslation } from 'react-i18next'
import { defaultUserProfile } from '../defaultUserProfile'

let idUser = 1000

type Props = {
  onAddProfile: (profile: UserProfile) => void
  profilesCount: number
}
export default function HousehouldMemberCreate({ onAddProfile, profilesCount }: Props) {
  const { t } = useTranslation()
  const [profile, setProfile] = React.useState<UserProfile>({
    ...defaultUserProfile,
    firstName: 'Household member ' + (profilesCount + 1)
  })
  return (
    <DialogTrigger>
      <Button variant="icon" className="HouseholdSelector-add">
        <FontAwesomeIcon icon={faPlus} width={10} height={10} color="var(--gray-500)" />
      </Button>
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>Household member</ModalHeader>

              <ModalContent style={{}}>
                <ProfileEditor
                  userProfile={profile}
                  onChangeProfile={setProfile}
                  isHouseholdProfile={true}
                />
              </ModalContent>
              <ModalFooter onClose={close}>
                <Button
                  variant="primary"
                  onPress={() => {
                    if (profile) {
                      onAddProfile(profile)
                    }
                    close()
                  }}>
                  Add member
                </Button>
              </ModalFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
